import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JWT_OPTIONS, JwtHelperService } from '@auth0/angular-jwt';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { DbsSpinnerModule } from '@careconne/core/components';
import { AUTH_TOKEN_INTERCEPTOR_FILTER } from '@careconne/core/configs';
import { CoreModule } from '@careconne/core/core.module';
import { CompleteRequestsInterceptor, JWTInterceptor, filterInterceptorRequest } from '@careconne/core/interceptors';
import { DetectDeviceService, HttpCancelService } from '@careconne/core/services/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

export const createTranslateLoader = (http: HttpClient) =>
  new TranslateHttpLoader(http, './assets/i18n/', '.json?t=' + new Date().getTime());

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    DbsSpinnerModule,
    CoreModule,
    TranslateModule.forRoot({
      defaultLanguage: 'jp',
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    HttpCancelService,
    JwtHelperService,
    {
      provide: JWT_OPTIONS,
      useValue: JWT_OPTIONS,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CompleteRequestsInterceptor,
      multi: true,
    },
    {
      provide: AUTH_TOKEN_INTERCEPTOR_FILTER,
      useValue: filterInterceptorRequest,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JWTInterceptor,
      multi: true,
    },
    DatePipe,
    DetectDeviceService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
